import { PermissionMode } from "./permission-mode";
import { PermissionType } from "./permission-type";

export enum PermissionSubjectType {
  User = "User",
  Group = "Group",
}

export interface PermissionInfos {
  defaultPermissions: PermissionType[] | null;
  specificPermissions: SpecificPermission[] | null;
}

export interface SpecificPermission {
  subjectType: PermissionSubjectType;
  subjectId: number;
  type: PermissionType;
  mode: PermissionMode;
}
